import { getLocalStorage, setLocalStorage } from '@zhenguo/jssdk/base/storage'

const SESSION = {
  IDENTITY: 'ZHENGUO_TALOS_VERIFY_EDU_IDENTITY',
  STUDENT: 'ZHENGUO_TALOS_VERIFY_EDU_STUDENT',
  EMAIL: 'ZHENGUO_TALOS_VERIFY_EDU_EMAIL',
}

export default {
  get student() {
    return getLocalStorage(SESSION.STUDENT, 'Object', {})
  },
  set student(data) {
    if (!data) {
      localStorage.removeItem(SESSION.STUDENT)
      return
    }
    setLocalStorage(SESSION.STUDENT, data)
  },
  get identity() {
    return getLocalStorage(SESSION.IDENTITY, 'Object', {})
  },
  set identity(data) {
    if (!data) {
      localStorage.removeItem(SESSION.IDENTITY)
      return
    }
    setLocalStorage(SESSION.IDENTITY, data)
  },
}
